// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { formatClassName } from '../../util/cts-gantry-util';
import { CtsGantryGridHighlightDirective } from '../../directives/cts-gantry-grid-highlight.directive';

@Component({
  standalone: true,
  imports: [CommonModule, CtsGantryGridHighlightDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-list',
  templateUrl: './cts-gantry-functional-unit-list.component.html',
  styleUrl: './cts-gantry-functional-unit-list.component.scss',
})
export class CtsGantryFunctionalUnitListComponent {
  @Input({ required: true }) functionalUnits: string[] = [];

  protected formatClassName(name: string): string {
    return formatClassName(name);
  }
}
